import React, { useState, useRef, useEffect, useMemo, useCallback } from "react";
import './CountryFlag.scss';
import { useSelector } from "react-redux";

const CountryFlag = ({ setPhoneCode }) => {
  const [selectedFlag, setSelectedFlag] = useState("IT"); // Default flag
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const { countries } = useSelector((state) => state.surveyInfo);

  const memoizedCountries = useMemo(() => {
    return countries?.map((country) => ({
      id: country.id,
      name: country.name,
      code: country.sortname,
      flag: `https://flagcdn.com/w40/${country.sortname.toLowerCase()}.png`,
      phoneCode: `+${country.phonecode}`,
    })) || [];
  }, [countries]);

  const handleClickOutside = useCallback((event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [handleClickOutside]);

  const handleSelectCountry = (country) => {
    // console.log(country.phoneCode, "country");
    setSelectedFlag(country.code);
    setIsOpen(false);
    setPhoneCode(country.phoneCode);
  };

  return (
    <div className="flag-input-container" ref={dropdownRef}>
      <div className="flag-input-box" onClick={() => setIsOpen(!isOpen)}>
        <div className="flag-select">
          <img
            src={`https://flagcdn.com/w40/${selectedFlag.toLowerCase()}.png`}
            alt="Selected Flag"
            className="flag-icon"
          />
        </div>
        <span className="arrow">▼</span>
      </div>

      {isOpen && (
        <div className="dropdown">
          <ul>
            {memoizedCountries.map((country) => (
              <li key={country.id} onClick={() => handleSelectCountry(country)}>
                <img src={country.flag} alt={country.name} className="flag-icon" />
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default CountryFlag;
